import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LoginPayload } from 'app/core/models/login-payload.model';
import { AuthService } from 'app/core/services/auth.service';
import { PortalSelectionService } from 'app/core/services/portal-selection.service';
import { generalAnimations } from 'app/shared/animations/animations';
import { isFormControlError } from 'app/shared/forms/utils/forms.utils';
import { DxButtonModule, DxDropDownButtonModule, DxTextBoxModule } from 'devextreme-angular';
import { environment } from 'environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    DxTextBoxModule,
    DxDropDownButtonModule,
    DxButtonModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: generalAnimations,
})
export class LoginComponent {
  private subscription = new Subscription();
  isFormControlError = isFormControlError;

  loginInvalid = false;

  oktaUrl = environment.oktaUrl;
  loginFormGroup: FormGroup = new FormGroup({
    username: new FormControl('', Validators.required),
  });

  constructor(
    private ref: ChangeDetectorRef,
    private authService: AuthService,
    private portalSelectionService: PortalSelectionService
  ) {}

  onLoginClick(): void {
    if (this.loginFormGroup.valid) {
      const login = this.loginFormGroup.getRawValue() as LoginPayload;
      this.subscribeToLogin(login);
    }
  }

  redirectToOkta(): void {
    window.location.href = this.oktaUrl;
  }

  private subscribeToLogin(loginDto: LoginPayload): void {
    this.subscription.add(
      this.authService.loginUser(loginDto).subscribe({
        next: res => {
          if (res.usernameTiedToNonce && res.id) {
            this.subscription.add(
              this.portalSelectionService
                .handlePortalSelection(res.id, res.usernameTiedToNonce)
                .subscribe()
            );
            return;
          }

          if (res) {
            this.loginInvalid = false;
            this.portalSelectionService.completeLogin(res);
            this.ref.markForCheck();
          }
        },
        error: () => {
          this.loginInvalid = true;
          this.ref.markForCheck();
        },
      })
    );
  }
}
